import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccesoService {

  uploadImage:any;

  constructor() { }

  desencriptarTOKEN() : any {

    //let encriptadoTOKEN = sessionStorage.getItem('Kn48Nki8is9dhan54648asm78f6s3JDF56L4Ndf2SDdas55');
    // console.log('TOKENencriptado', encriptadoTOKEN)
    //let arregloTOKEN = encriptadoTOKEN.split('ñ',10);
    //let TOKEN = arregloTOKEN[4];
    let TOKEN = environment.secret_key;
    // console.log('TOKEN', TOKEN);
    let headers :  HttpHeaders = new HttpHeaders();
    headers =  headers.append('Accept', 'application/json');
    headers =  headers.append('Authorization', `${TOKEN}`);


    return headers;
  }
}
